<template>
  <div class="video-error">
    <h3>{{ videoErrorHeading }}</h3>

    <p>
      {{ videoErrorText1 }} {{ error }}. {{ videoErrorText2 }}
    </p>
  </div>
</template>

<script>
export default {
  name: "VideoError",
  props: ["error", "videoErrorHeading", "videoErrorText1", "videoErrorText2"]
}
</script>

<style lang="scss" scoped>
  .video-error {
    text-align: center;
    max-width: 400px;

    p {
      font-size: 80%;
    }
  }
</style>
